import { makeUseAxios } from "axios-hooks";

import { Config } from "@/utils/config.utils";

import { createApiFor, ExtendedUseAxios } from "./utils";

const productServiceAxiosInstance = createApiFor(
    `/productservice/${Config.general.basestore}`
);

const useProductServiceApi = makeUseAxios({
    axios: productServiceAxiosInstance,
    defaultOptions: {
        ssr: false,
        manual: false
    }
}) as ExtendedUseAxios;

const useProductService = () => {
    return productServiceAxiosInstance;
};

const bffProductServiceAxiosInstance = createApiFor(
    `/${Config.general.basestore}`,
    {
        bff: true
    }
);

const useBFFProductService = () => {
    return bffProductServiceAxiosInstance;
};

const useBFFProductServiceApi = makeUseAxios({
    axios: bffProductServiceAxiosInstance,
    defaultOptions: {
        ssr: false,
        manual: false
    }
}) as ExtendedUseAxios;

export {
    useBFFProductService,
    useBFFProductServiceApi,
    useProductService,
    useProductServiceApi
};
